module.exports = __webpack_public_path__ + "static/media/primary_seller_icon.d1230fba.svg";